import { render, staticRenderFns } from "./quarter.vue?vue&type=template&id=ed979eb8&scoped=true"
import script from "./quarter.vue?vue&type=script&lang=js"
export * from "./quarter.vue?vue&type=script&lang=js"
import style0 from "./quarter.vue?vue&type=style&index=0&id=ed979eb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed979eb8",
  null
  
)

export default component.exports